import React, { useState, useEffect } from 'react';
import moment from 'moment'
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Modal, Input, Select, Button, Form, DatePicker, Alert } from 'antd';
import { CREATE_RESERVATION, UPDATE_RESERVATION } from '../../redux/actions/type'
import {
    dateToMillisecond,
    convertWithDutationTime,
    disabledPastDay,
    genVRoomToken,
    postHttpClient,
    convertMillisecondToDate,
    dateDiffDuration,
    putHttpClient,
    validateEmail,
    secondsContextToHms
} from '../../helpers'
import { capitalize, get, isEmpty, lowerCase } from 'lodash';
import { translate } from 'react-i18next'
import { checkTokenExpire } from '../../redux/actions/actions'
import dateCN from 'antd/es/date-picker/locale/zh_CN';
import dateTh from 'antd/es/date-picker/locale/th_TH';
import dateEn from 'antd/es/date-picker/locale/en_US';



const { TextArea } = Input;
const { Option } = Select

const ModalReservation = ({
    visible,
    title,
    setReservation,
    action,
    keycloak,
    activeItem,
    reservObj,
    t,
    authenticated,
    calendarSelect,
    contextInfo,
    language
}) => {
    const dispatch = useDispatch()

    const [form] = Form.useForm();

    const [userInfo, setuserInfo] = useState({
        email: ''
    })

    //  event checkbox
    const [checkbox, setCheckbox] = useState({
        activePassword: false
    })

    // event disabled form while status change.
    const [disabledForm, setDisabledForm] = useState(false)

    // vroom name error.
    const [nameError, setnameError] = useState({
        isError: false,
        message: null
    })

    // vroom date time error.
    const [dateTimeError, setDateTimeError] = useState({
        isError: false,
        message: null
    })

    // duration time error.
    const [durationError, setdurationError] = useState({
        isError: false,
        message: null
    })

    // alert model error
    const [modalError, setmodalError] = useState({
        isError: false,
        message: null
    })

    // detail input
    const [detailInput, setDetailInput] = useState({
        value: null,
        length: 0
    })

    // moderator error
    const [moderatorError, setModeratorError] = useState({
        isError: false,
        message: null
    })

    // limit duration time by package.
    const [limitDuration, setlimitDuration] = useState({
        hours: 0,
        minutes: 0
    })

    // duration select option
    const [minOption, setMinOption] = useState([])

    //handle btn loading when submit
    const [btnLoading, setbtnLoading] = useState(false)

    /**
     * Checked active password.
     */
    const handleActivePassword = e => {
        if (e.target.checked) {
            setCheckbox({
                ...checkbox,
                activePassword: !checkbox.activePassword
            })
        } else {
            setCheckbox({
                ...checkbox,
                activePassword: !checkbox.activePassword
            })
            form.setFieldsValue({ password: null })
        }
    }

    /**
     * Close modal and Reset modal Components.
     */
    const handleVroomCancle = () => {
        //reset modal
        setmodalError({ isError: false })
        setReservation(false)
        //reset form
        form.resetFields()
        setCheckbox({
            activePassword: false,
        })
        setDisabledForm(false)
        setnameError({ isError: false })
        setDateTimeError({ isError: false })
        setdurationError({ isError: false })
        setDetailInput({
            value: null,
            length: 0
        })
        setModeratorError({ isError: false })
        setMinOption([])
    }


    /**
     * Limit duration hour optin while change value.
     * @param {*} value 
     */
    const handleDurationHours = value => {
        let minutes = form.getFieldValue(['minutes'])
        if (durationError.isError) {
            setdurationError({ isError: false })
        }
        // while select minutes done and back to select hour.
        if ((minutes >= limitDuration.minutes) && (parseInt(value) >= limitDuration.hours)) {
            form.setFieldsValue({
                minutes: limitDuration.minutes
            })
        }
        if (parseInt(value) === 0 && parseInt(minutes) === 0) {
            form.setFieldsValue({
                minutes: null
            })
        }
        changeMinOption(value);
    }

    /**
     * Limit duration minutes optin while change value.
     * @param {*} value 
     */
    const handleDurationMins = value => {
        let hours = form.getFieldValue(['hours'])

        if (durationError.isError) {
            setdurationError({ isError: false })
        }
        if (parseInt(value) === 0 && parseInt(hours) === 0) {
            form.setFieldsValue({
                hours: null
            })
        }
    }

    /**
     * default hours select duration
     */
    const defaultHourOption = () => {
        let hourVal = limitDuration.hours
        let hourArr = []
        for (let i = 0; i <= hourVal; i++) {
            hourArr.push(<Option key={i}>{i} {t('reservation_modal_form.hr')} </Option>);
        }
        return hourArr
    }

    /**
     * select minutes option duration
     * @param {*} limitHour 
     */
    const changeMinOption = (limitHour) => {
        const minVal = [0, 10, 20, 30, 40, 50]
        const minArr = []
        for (let i = 0; i < minVal.length; i++) {
            // case select max limit package
            if (parseInt(limitHour) === parseInt(limitDuration.hours) && (parseInt(limitDuration.hours) !== 0)) {
                if (minVal[i] <= limitDuration.minutes) {
                    minArr.push(<Option key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
                } else {
                    minArr.push(<Option disabled key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
                }
            } else if (parseInt(limitHour) > 0) {
                minArr.push(<Option key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
            } else {
                if (minVal[i] === 0) {
                    minArr.push(<Option disabled key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
                } else {
                    minArr.push(<Option key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
                }
            }

        }
        setMinOption(minArr)
    }

    /**
     * default minute select duration
     */
    const defaultMinOption = () => {
        const minVal = [0, 10, 20, 30, 40, 50]
        const minArr = []
        for (let i = 0; i < minVal.length; i++) {
            if (limitDuration.hours === 0 && minVal[i] === 0) {
                minArr.push(<Option disabled key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
            } else {
                minArr.push(<Option key={minVal[i]}>{minVal[i]} {t('reservation_modal_form.min')}</Option>);
            }
        }
        return minArr
    }

    /**
     * handle moderator input.
     * @param {*} value 
     */
    const handleModerator = value => {
        let lastValue = value[value.length - 1]
        //validate Email
        if (lastValue !== undefined && !validateEmail(lastValue)) {
            value.pop()
            setModeratorError({
                isError: true,
                message: t("reservation_modal_form_err.email_invalid")
            })
        } else {
            setModeratorError({
                isError: false,
                message: null
            })
        }
        //default value
        if (value.length === 0 || value.indexOf(userInfo.email) < 0) {
            value.unshift(userInfo.email)
        }
    }

    /**
    * handle Detail show detail character length.
    * @param {*} e 
    */
    const handleDetail = (e) => {
        setDetailInput({
            value: e.target.value,
            length: e.target.value.length
        })
    }

    const handleDateTime = (date, string) => {

    }

    /**
     * handle on datepicker change.
     * @param {*} open 
     */
    const handleDatepickerOpen = async (open) => {
        let dateHeader = await document.getElementsByClassName('ant-picker-header-view')
        if (dateHeader[1]) {
            dateHeader[1].innerHTML = t("hh_mm")
        }
    }

    /**
     * handle reservation fail submit and response from api
     * @param {*} param0 
     */
    const handleReservationFail = ({ code, message }) => {
        let statusCode = parseInt(code)
        if (statusCode === 40921 || statusCode === 40922) {
            setnameError({
                isError: true,
                message: t("reservation_modal_form_err.name_duplicate")
            })
        } else if (statusCode === 40023) {
            setdurationError({
                isError: true,
                message: t("reservation_modal_form_err.limit_duration")
            })
        } else if (statusCode === 40025) {
            setDateTimeError({
                isError: true,
                message: t("reservation_modal_form_err.date_future")
            })
        } else {
            setmodalError({
                isError: true,
                message
            })
        }
    }

    /**
     * Create reservation via api.
     * @param {*} payload 
     */
    const createReservation = async (payload) => {
        const urlReservation = `${window._env_.reservation}api/v1/reservations`

        if (!payload['active_password']) {
            delete payload.password
        }

        try {
            const token = await genVRoomToken(keycloak)
            const { password, detail, end_dt, name, start_dt, moderators } = payload
            const createReservation = await postHttpClient(keycloak, urlReservation, { Authorization: "Bearer " + token }, { password, detail, end_dt, name, start_dt, moderators })
            return createReservation
        } catch (error) {
            console.log('create reservation error')
        }
    }

    /**
     * Update duration via api.
     * @param {*} payload 
     * @param {*} id 
     */
    const updateReservation = async (payload, id) => {
        const urlReservation = `${window._env_.reservation}api/v1/reservations/${id}`

        if (!payload['active_password']) {
            delete payload.password
        }

        try {
            const token = await genVRoomToken(keycloak)
            const { password, detail, end_dt, name, start_dt, moderators } = payload
            const updateReservation = await putHttpClient(keycloak, urlReservation, { Authorization: "Bearer " + token }, { password, detail, end_dt, name, start_dt, moderators })
            return updateReservation
        } catch (error) {
            console.log('update reservation error')
        }
    }

    const isValidName = (name) => {
        let reg = /^[ก-๙a-zA-Z0-9_-]{1,100}$/
        return reg.test(name)
    }

    /**
     * Submit modal form.
     * @param {*} values 
     */
    const onFinish = async values => {
        dispatch(checkTokenExpire)
        // setbtnLoading(true)

        if (!isValidName(values['name'])) {
            setnameError({
                isError: true,
                message: t("reservation_modal_form_err.name_invalid")
            })
            setbtnLoading(false)
            return
        }

        let date = values['dateTime'].format('MM/DD/YYYY HH:mm')
        let payload = {
            code: null,
            message: null
        }
        let typeAction = action === lowerCase('create') ? CREATE_RESERVATION : UPDATE_RESERVATION

        values['start_dt'] = dateToMillisecond(date)
        values['end_dt'] = convertWithDutationTime(date, values['hours'], values['minutes'])
        values['active_password'] = checkbox.activePassword

        payload = (action === lowerCase('create')) ? await createReservation(values) : await updateReservation(values, activeItem)

        setbtnLoading(false)

        if (payload.code !== undefined) {
            handleReservationFail(payload)
        } else {
            dispatch({
                type: typeAction,
                payload: payload
            })
            handleVroomCancle(values, activeItem)
        }
    };

    /**
     * Sumit modal form when fail.
     * @param {*} errorInfo 
     */
    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };


    const setDateLang = () => {
        if (language === 'cn') {
            return dateCN
        } else if (language === 'th') {
            return dateTh
        } else {
            return dateEn
        }
    }

    /**
     * useEffect for handle form.
     */
    useEffect(() => {
        // if else for remove warning ant design.
        if (!isEmpty(activeItem) && lowerCase(action) === 'edit') {
            //Case update reservation
            const { name, detail, password, start_dt, end_dt, status, moderators } = reservObj
            const { hours, minutes } = (dateDiffDuration(start_dt, end_dt))
            //default form input value
            form.setFieldsValue({
                name,
                detail,
                password,
                dateTime: moment(convertMillisecondToDate(start_dt)),
                hours,
                minutes,
                moderators
            })
            if (password) {
                setCheckbox({
                    activePassword: true
                })
            }
            // Can update while status only equal schedule.
            if (lowerCase(status) !== 'schedule') {
                setDisabledForm(true)
            }
            setDetailInput({
                value: detail,
                length: (detail ? detail.length : 0)
            })
        } else if (lowerCase(action) === 'create') {
            // default form input value
            form.setFieldsValue({
                moderators: [userInfo.email],
                dateTime: calendarSelect
            })
        } else {
            //action else
        }

    }, [activeItem, reservObj, action, form, userInfo.email, calendarSelect])

    /**
     * useEffect for looking timlimit user package.
     */
    useEffect(() => {
        if (authenticated) {
            let { p } = contextInfo
            let timePackage = secondsContextToHms(p)
            setlimitDuration(timePackage)
            setuserInfo(contextInfo)
        }
    }, [authenticated, contextInfo])

    return (
        <Modal
            visible={visible}
            title={title}
            onCancel={handleVroomCancle}
            className="reservation-vroom-modal"
            footer={[
                btnLoading ? (<Button key="submit" form="modal-reservation-form" className="btn-submit-reservation-vroom" loading>
                    {capitalize(action)}
                </Button>) : (
                        <Button form="modal-reservation-form" key="submit" htmlType="submit" className="btn-submit-reservation-vroom" >
                            {capitalize(action) === 'Create' ? t("reservation_modal_form.reserve") : t("reservation_modal_form.OK")}
                        </Button>
                    ),
                <Button key="back" className="btn-submit-cancel-vroom" onClick={handleVroomCancle}>
                    {t("reservation_modal_form.cancel")}
                </Button>
            ]}
            destroyOnClose={true}
        >

            {modalError.isError ? <Alert message={modalError.message} type="error" showIcon /> : null}

            <Form
                form={form}
                name="modal-reservation-form"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
            >
                <Row>
                    <Col span={24}>
                        {
                            nameError.isError ? (
                                <Form.Item
                                    className="v-room-name-input"
                                    label={t("reservation_modal_form.room_name")}
                                    validateStatus="error"
                                    help={nameError.message}
                                    rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.room_name")} ` }]}
                                    name="name"
                                >
                                    <Input
                                        type="text"
                                        className="reservation-vroom-input"
                                        maxLength="100"
                                        disabled={lowerCase(action) === 'edit' ? true : false}
                                        onChange={() => setnameError({ isError: false })}
                                    />
                                </Form.Item>
                            ) : (
                                    <Form.Item
                                        className="v-room-name-input"
                                        label={t("reservation_modal_form.room_name")}
                                        rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.room_name")} ` }]}
                                        name="name"
                                    >
                                        <Input
                                            type="text"
                                            className="reservation-vroom-input"
                                            maxLength="100"
                                            disabled={lowerCase(action) === 'edit' ? true : false}
                                        />
                                    </Form.Item>
                                )
                        }
                    </Col>
                </Row>
                <Row className="modal-custom-checkbox">
                    <Col span={2} className="modal-active-password">
                        <label className="modal-container-checkbox">
                            <input type="checkbox" id="v-room-active-checkbox" disabled={disabledForm} checked={checkbox.activePassword} onChange={(e) => handleActivePassword(e)} />
                            <span className="checkmark"></span>
                        </label>
                    </Col>
                    <Col span={22}>
                        <label>{t("reservation_modal_form.active_password")}</label>
                    </Col>
                </Row>
                <Row style={{ display: checkbox.activePassword ? 'block' : 'none' }}>
                    <Col span={24}>
                        <Form.Item
                            className="v-room-name-input"
                            label={t("reservation_modal_form.password")}
                            rules={[{ required: checkbox.activePassword, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.password")}` }]}
                            name="password"
                        >
                            <Input.Password
                                className="reservation-vroom-input"
                                maxLength="50"
                                name="password"
                                disabled={disabledForm}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        {
                            moderatorError.isError ? (
                                <Form.Item
                                    className="v-room-name-input"
                                    name="moderators"
                                    label={t("reservation_modal_form.moderator")}
                                    rules={[
                                        { type: 'array' },
                                    ]}
                                    validateStatus="error"
                                    help={moderatorError.message}
                                >
                                    <Select disabled={disabledForm} mode="tags" placeholder="Moderator" onChange={handleModerator}>
                                    </Select>
                                </Form.Item>
                            ) : (
                                    <Form.Item
                                        className="v-room-name-input"
                                        name="moderators"
                                        label={t("reservation_modal_form.moderator")}
                                        rules={[
                                            { type: 'array' },
                                        ]}
                                    >
                                        <Select disabled={disabledForm} mode="tags" placeholder="Moderator" onChange={handleModerator}>
                                        </Select>
                                    </Form.Item>
                                )
                        }
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        {
                            dateTimeError.isError ? (
                                <Form.Item
                                    className="v-room-name-input"
                                    name="dateTime"
                                    label={t("reservation_modal_form.date")}
                                    validateStatus="error"
                                    help={dateTimeError.message}
                                    rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.date")}` }]}
                                >
                                    <DatePicker
                                        showTime
                                        format="MM/DD/YYYY HH:mm"
                                        placeholder="MM/DD/YYYY hh:mm"
                                        disabledDate={disabledPastDay}
                                        disabled={disabledForm}
                                        minuteStep={10}
                                        onChange={() => setDateTimeError({ isError: false })}
                                        onOpenChange={handleDatepickerOpen}
                                        locale={setDateLang()}
                                    />
                                </Form.Item>
                            ) : (
                                    <Form.Item
                                        className="v-room-name-input"
                                        name="dateTime"
                                        label={t("reservation_modal_form.date")}
                                        rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.date")}` }]}
                                    >
                                        <DatePicker
                                            showTime
                                            format="MM/DD/YYYY HH:mm"
                                            placeholder="MM/DD/YYYY hh:mm"
                                            disabled={disabledForm}
                                            disabledDate={disabledPastDay}
                                            minuteStep={10}
                                            onChange={handleDateTime}
                                            onOpenChange={handleDatepickerOpen}
                                            locale={setDateLang()}
                                        />
                                    </Form.Item>
                                )
                        }
                    </Col>
                    <Col span={12}>
                        <div className="v-room-duration-input">
                            {
                                durationError.isError ? (
                                    <>
                                        <Form.Item
                                            label={t("reservation_modal_form.time")}
                                            name="hours"
                                            validateStatus="error"
                                            help=" "
                                            rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.hours")}` }]}
                                        >
                                            <Select
                                                showSearch
                                                style={{ width: 100 }}
                                                placeholder={t("reservation_modal_form.hours")}
                                                onChange={handleDurationHours}
                                                disabled={disabledForm}
                                            >
                                                {defaultHourOption()}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label=" "
                                            name="minutes"
                                            validateStatus="error"
                                            help=" "
                                            rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.minutes")}` }]}
                                            style={{ marginTop: '2px' }}
                                        >
                                            <Select
                                                showSearch
                                                style={{ width: 100 }}
                                                placeholder={t("reservation_modal_form.minutes")}
                                                disabled={disabledForm}
                                                onChange={handleDurationMins}
                                            >
                                                {minOption.length === 0 ? defaultMinOption() : minOption}
                                            </Select>
                                        </Form.Item>
                                    </>
                                ) : (
                                        <>
                                            <Form.Item
                                                label={t("reservation_modal_form.time")}
                                                name="hours"
                                                rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.hours")}` }]}
                                            >
                                                <Select
                                                    showSearch
                                                    style={{ width: 100 }}
                                                    placeholder={t("reservation_modal_form.hours")}
                                                    onChange={handleDurationHours}
                                                    disabled={disabledForm}
                                                >
                                                    {defaultHourOption()}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                label=" "
                                                name="minutes"
                                                rules={[{ required: true, message: `${t("reservation_modal_form_err.specify")}${t("reservation_modal_form.minutes")}` }]}
                                                style={{ marginTop: '2px' }}
                                            >
                                                <Select
                                                    showSearch
                                                    style={{ width: 100 }}
                                                    placeholder={t("reservation_modal_form.minutes")}
                                                    disabled={disabledForm}
                                                    onChange={handleDurationMins}
                                                >
                                                    {minOption.length === 0 ? defaultMinOption() : minOption}
                                                </Select>
                                            </Form.Item>
                                        </>
                                    )
                            }
                        </div>
                        {durationError.isError ? <Col style={{ marginTop: '-20px', color: '#FF0000' }}>{durationError.message}</Col> : null}
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            className="v-room-name-input"
                            name="detail"
                            label={t("reservation_modal_form.detail")}
                        >
                            <TextArea name="detail" rows={4} maxLength="10000" onChange={(e) => handleDetail(e)} />
                        </Form.Item>
                        <Col span={24} style={{ marginTop: '-20px', float: 'right', color: detailInput.length >= 9900 ? '#FF0000' : '#BDBDBD' }}>
                            {`${detailInput.length}/10000`}
                        </Col>
                    </Col>
                </Row>

            </Form>
        </Modal >
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, 'keycloak', ''),
    activeItem: get(state, 'reservation.activeItem', ''),
    authenticated: get(state, 'keycloak.authenticated', false),
    contextInfo: get(state, 'contextInfo', ''),
    language: get(state, 'language', 'en')
})
export default connect(mapStateToProps, null)(translate()(ModalReservation))
